import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import {
  Box,
  MenuItem,
  TextField,
  InputAdornment,
  Icon,
  Typography,
  Checkbox,
} from "@mui/material";

function SelectField({ displayName, fieldRef, options, editable = false }) {
  const [selectedOption, setSelectedOption] = useState(null);
  const [enableEditable, setEnableEditable] = useState(false);

  useEffect(() => {
    if (selectedOption === null) {
      return;
    }

    const watchField = document.getElementById(`dff_${fieldRef}`);
    watchField.dispatchEvent(new Event('change'));
  }, [selectedOption]);

  return (
    <Box mt={4}>
      <TextField
        select
        fullWidth
        // name={fieldRef}
        label={displayName}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Icon>checklist</Icon>
            </InputAdornment>
          ),
        }}
        onChange={(e) => {
          if (editable === true) {
            setEnableEditable(false);
          }
          setSelectedOption(e.target.value);
        }}
        value={selectedOption}
      >
        {editable === true && (
          <MenuItem value={null}>Select an option</MenuItem>
        )}
        {options.map((option) => (
          <MenuItem value={option.value}>{option.name}</MenuItem>
        ))}
      </TextField>
      {editable === true && (
        <Box mt={2}>
          <Box display="flex" alignItems="center" ml={-1}>
            <Checkbox
              checked={enableEditable}
              onChange={(e) => {
                setSelectedOption(null);
                setEnableEditable(e.target.checked);
              }}
              inputProps={{ "aria-label": "controlled" }}
            />
            <Typography
              variant="subtitle2"
              fontWeight="regular"
              color="text"
              sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
            >
              &nbsp;&nbsp;Enter your own {displayName}?
            </Typography>
          </Box>
          {enableEditable === true && (
            <Box mt={1}>
              <TextField
                placeholder={`Enter your ${displayName}`}
                margin="dense"
                label={displayName}
                type="text"
                fullWidth
                variant="outlined"
                value={selectedOption}
                onChange={(e) => setSelectedOption(e.target.value)}
              />
            </Box>
          )}
        </Box>
      )}
      <input
        type="hidden"
        id={`dff_${fieldRef}`}
        name={fieldRef}
        value={selectedOption}
      />
    </Box>
  );
}

// Typechecking props of the Transaction
SelectField.propTypes = {
  fieldRef: PropTypes.string.isRequired,
  displayName: PropTypes.string.isRequired,
  editable: PropTypes.bool,
  options: PropTypes.arrayOf(PropTypes.any),
};

SelectField.defaultProps = {
  options: null,
  editable: false,
};
export default SelectField;
